import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ProcessPage } from './pages/ProcessPage';
import { ResultsPage } from './pages/ResultsPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/4Z9hCxF9GbFsHJdtqTcfuJ/Captura_de_pantalla_2026-05-21_a_las_16.06.43.png';
export function App() {
  // Set browser tab title and favicon
  useEffect(() => {
    document.title = 'Growthly LLC';
    const setFavicon = (rel: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = FAVICON_URL;
    };
    setFavicon('icon');
    setFavicon('shortcut icon');
    setFavicon('apple-touch-icon');
  }, []);
  return <Router data-id="element-0" data-mp="4n6o4eeqtbm">
      <div className="min-h-screen bg-black font-sans text-gray-100 selection:bg-white selection:text-black" data-id="element-1" data-mp="56ntiw8hdol">
        <Navbar data-id="element-2" data-mp="2zn6b4vo3kbmp" />
        <main className="overflow-hidden" data-id="element-3" data-mp="33mov9p83gioh">
          <Routes data-id="element-4" data-mp="33nq55qddiz4m">
            <Route path="/" element={<HomePage data-id="element-6" data-mp="33oi2p6qj76xj" />} data-id="element-5" data-mp="33n6wl09m5n39" />
            <Route path="/servicios" element={<ServicesPage data-id="element-8" data-mp="38l06o4e1f18t" />} data-id="element-7" data-mp="38l8iru2c62iy" />
            <Route path="/proceso" element={<ProcessPage data-id="element-10" data-mp="3dle1gkqmoeow" />} data-id="element-9" data-mp="38num1hi71vvd" />
            <Route path="/resultados" element={<ResultsPage data-id="element-12" data-mp="3diry6xarslch" />} data-id="element-11" data-mp="3dlnukh6yz1yt" />
            <Route path="/faq" element={<FAQPage data-id="element-14" data-mp="nuhj4kutefvc" />} data-id="element-13" data-mp="nw2ay2pqvkpi" />
            <Route path="/contacto" element={<ContactPage data-id="element-16" data-mp="sunf2d84aoj8" />} data-id="element-15" data-mp="nvaszup2llhp" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-18" data-mp="sssrer5goibg" />} data-id="element-17" data-mp="stkm7zr8ic0o" />
            <Route path="/privacidad" element={<PrivacyPage data-id="element-20" data-mp="35glr3hkw7k1" />} data-id="element-19" data-mp="36hvn4muyo06" />
            <Route path="/terminos" element={<TermsPage data-id="element-22" data-mp="3uct3bjmdin0h" />} data-id="element-21" data-mp="34nbvtnbp1xo" />
          </Routes>
        </main>
        <Footer data-id="element-23" data-mp="3uc9o4ao3ycq5" />
      </div>
    </Router>;
}